module.exports = "/_next/static/images/7e3823c3b4f3e912607f0418eecdc4bb-cajitas-left-desktop.jpg";